var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyBilling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.13,14.01v34.38c0,2.59-2.1,4.69-4.7,4.69H8.57c-2.6,0-4.7-2.1-4.7-4.69V14.01c0-2.59,2.1-4.69,4.7-4.69 h46.86C58.03,9.32,60.13,11.42,60.13,14.01z M8.57,14.59v4.1h46.86v-4.1c0-0.32-0.26-0.59-0.59-0.59H9.16 C8.84,14.01,8.57,14.27,8.57,14.59z M55.43,47.8v-16.6H8.57v16.6c0,0.32,0.26,0.59,0.59,0.59h45.68 C55.16,48.38,55.43,48.12,55.43,47.8z M22.63,42.52c0,0.64-0.53,1.17-1.17,1.17h-7.03c-0.64,0-1.17-0.53-1.17-1.17v-3.91 c0-0.64,0.53-1.17,1.17-1.17h7.03c0.64,0,1.17,0.53,1.17,1.17V42.52z M41.38,42.52c0,0.64-0.53,1.17-1.17,1.17H26.92 c-0.64,0-1.17-0.53-1.17-1.17v-3.91c0-0.64,0.53-1.17,1.17-1.17H40.2c0.64,0,1.17,0.53,1.17,1.17V42.52z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBilling);
export default __webpack_public_path__ + "static/media/my_billing.2b7e51a3d045d147b96d1aa88a57bef9.svg";
export { ForwardRef as ReactComponent };